import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    previewContainer: {
      padding: '0',
    },
    previewList: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    previewListItem: {
      display: 'flex',
      flexDirection: 'column',
      width: 'fit-content',
      height: 'fit-content',
    },
    previewItem: {
      width: '150px',
      height: '150px',
      overflow: 'hidden',
    },
    preview: {
      width: '100%',
      height: 'auto',
    },
    subtitle: {
      marginBottom: 10,
    },
    addButtonContainer: {
      width: '100%',
      marginBottom: 15,
      flexDirection: 'column',
    },
    addButton: {
      width: 150,
      backgroundColor: 'white',
    },
    accordionContainer: {
      backgroundColor: '#eaeaea',
    },
    buttonWrapper: {
      width: '100%',
      position: 'relative',
    },
    filePreview: {
      backgroundColor: '#FFFFFF',
      paddingTop: 35,
    },
    imgContainer:{
      padding: 15,
      borderRadius: 10,
      marginTop: 20,
      width: "100%",
      backgroundColor: "#FFFFFF",
      marginBottom: 15,
      boxShadow: theme.shadows[1],
      display: "flex",
      flexDirection: "row",
    },
    imgPreviewContainer: {
      display: "flex",
      flexDirection: 'column',
      width: 200,
      height: 200,
      marginRight: 15
    },
    imagePreview:{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: 10,
      marginBottom: 10,
      overflow: 'hidden',
      border: '3px solid #FFFFFF',
    },
    imgDescription:{
      width: '100%',
    },
    fileName: {
      maxWidth: 150,
      marginRight: 15,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& img': {
        objectFit: 'cover',
        zIndex: 0,
      },
      '& p': {
        overflowWrap: 'anywhere',
      },
    },
  }),
);
